/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { cn } from '../../lib/utils/cn.js';

import type { JSX } from 'react';

export type BadgeTone = 'green' | 'slate' | 'amber' | 'violet' | 'rose';

const TONES: Readonly<Record<BadgeTone, string>> = {
  green: 'bg-emerald-50 text-emerald-700',
  slate: 'bg-slate-100 text-slate-600',
  amber: 'bg-amber-50 text-amber-700',
  violet: 'bg-violet-50 text-violet-700',
  rose: 'bg-rose-50 text-rose-700',
};

interface BadgeProps {
  readonly label: string;
  readonly tone?: BadgeTone;
}

/** Small status/category pill. `label` is pre-translated by the caller. */
export function Badge({ label, tone = 'slate' }: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONES[tone],
      )}
    >
      {label}
    </span>
  );
}
